// Classes
const baseClass = 'amplify-storytelling-image-map';
const containerClass = `${baseClass}-container`;
const mediaClass = `${containerClass}__media`;
const hotspotClass = `${baseClass}-hotspot`;

export const CLASSES = {
  CONTAINER: containerClass,
  CONTAINER_CONTENTS: `${containerClass}__contents`,
  MEDIA: mediaClass,
  HOTSPOT: hotspotClass,
}
